import PropTypes from "prop-types"
import { CChevronDownFilled, CChevronUpFilled } from "../../../../shared/Icons"

const SortingArrow = ({ isSorted, isSortedDesc }) => {
  return isSorted ? (
    isSortedDesc ? (
      <CChevronDownFilled boxSize="4" />
    ) : (
      <CChevronUpFilled boxSize="4" />
    )
  ) : (
    <CChevronDownFilled boxSize="4" color="gray.400" />
  )
}

export default SortingArrow

SortingArrow.propTypes = {
  isSorted: PropTypes.bool,
  isSortedDesc: PropTypes.bool,
}
